export default "__VITE_ASSET__B_I0blGA__"